// extracted by mini-css-extract-plugin
export var generatorCard = "GeneratorCard-module--generatorCard--2pTWV";
export var generatorCardMain = "GeneratorCard-module--generatorCardMain--1v2bN";
export var generatorCardHeader = "GeneratorCard-module--generatorCardHeader--ZzZnb";
export var generatorCardSubHeader = "GeneratorCard-module--generatorCardSubHeader--2d7o1";
export var icon = "GeneratorCard-module--icon--1TrO4";
export var generatorCardAttributes = "GeneratorCard-module--generatorCardAttributes--3zmxD";
export var attribute = "GeneratorCard-module--attribute--18krO";
export var attributeName = "GeneratorCard-module--attributeName--3Ubn1";
export var attributeValue = "GeneratorCard-module--attributeValue--2dqlc";
export var hidden = "GeneratorCard-module--hidden--3KOJS";